/**
 * Capitalize the first letter of a string
 */
export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * The single source of truth for how a role is written in the UI.
 *
 * Role *values* stay as the backend defines them (LERNENDE,
 * PRACTICE_INSTRUCTOR, ...) - only the wording shown to people is unified
 * here, so "Lernende"/"Learner" and "Praxisbildner"/"PRACTICE_INSTRUCTOR"
 * never appear side by side again.
 */
export const ROLE_LABELS = {
  ADMIN: 'Admin',
  BERUFSBILDNER: 'Berufsbildner',
  PRAXISBILDNER: 'Practice Instructor',
  PRACTICE_INSTRUCTOR: 'Practice Instructor',
  LERNENDE: 'Apprentice',
  LEARNER: 'Apprentice',
  REVISOR: 'Revisor',
  EXPERT: 'Expert',
};

/**
 * Format role name for display. Tolerates the "ROLE_" prefix and the role
 * object shapes ({ name } / { authority }) used across the app.
 */
export const formatRoleName = (role) => {
  if (!role) return '';

  const raw =
    typeof role === 'string' ? role : role.name || role.authority || '';
  const key = raw.toUpperCase().replace(/^ROLE_/, '');
  if (!key) return '';

  return ROLE_LABELS[key] || capitalize(key.replace(/_/g, ' '));
};

/**
 * Format profession type for display
 */
export const formatProfessionType = (professionType) => {
  if (!professionType) return '';
  
  const professionMap = {
    'APPLIKATIONSENTWICKLER': 'Application Developer',
    'PLATTFORMENTWICKLER': 'Platform Developer'
  };
  
  return professionMap[professionType] || capitalize(professionType);
};

/**
 * Truncate text to a specified length
 */
export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

/**
 * Generate avatar initials, e.g. "Selina Mogicato" -> "SM".
 *
 * Always uppercase and never spaced: lowercase account names such as
 * "demo demo" would otherwise render as "d d" in an avatar circle.
 * Falls back to the username when no name is set.
 */
export const getInitials = (firstName, lastName, fallback = '') => {
  const first = firstName ? firstName.trim().charAt(0) : '';
  const last = lastName ? lastName.trim().charAt(0) : '';
  const initials = `${first}${last}`;

  if (initials) return initials.toUpperCase();
  return fallback ? fallback.trim().charAt(0).toUpperCase() : '';
};